<template>
  <div class="bg">
    <v-app id="inspire">
      <!-- <v-content> -->
      <v-container fluid fill-height>
        <v-layout pa-7 align-center justify-center>
          <v-flex xs12 sm8>
            <v-spacer />
            <v-card class="elevation-12 pa-5">
              <v-toolbar-title>
                <v-img class="logo mt-2" src="logo-color.png" />
              </v-toolbar-title>
              <v-card-text>
                <div v-if="loading" class="text-xs-center">
                  <v-progress-circular
                    :size="75"
                    :width="4"
                    color="primary"
                    indeterminate
                  />
                </div>
                <div v-else class="subheading font-weight-medium">
                  <v-alert
                    v-if="message"
                    :value="true"
                    :type="error ? 'error' : 'success'"
                  >
                    {{ message }}
                  </v-alert>
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  small
                  color="primary"
                  @click="
                    loggedIn
                      ? $router.push({ name: 'matches' })
                      : $router.push({ name: 'login' })
                  "
                >
                  <v-icon larg> home </v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- </v-content> -->
      <!-- <v-footer class="pa-3 footer-bg">
        <span class="caption">FBASE.Tv &copy; {{ new Date().getFullYear() }}</span>
        <v-spacer></v-spacer>
        <span class="caption mr-1">
          <a to>{{$t('titles.global.termsAndConditions')}}</a> |
          <a to>{{$t('titles.global.termsOfUse')}}</a>
        </span>
      </v-footer> -->
    </v-app>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data: () => ({
    message: '',
    error: false,
    loading: false,
  }),
  computed: {
    loggedIn() {
      return this.$store.state.auth.user
    },
  },
  mounted() {
    this.send()
  },
  methods: {
    ...mapActions({
      acceptInvitation: 'teams/acceptInvitation',
    }),
    send() {
      const payload = {
        teamId: this.$route.params.teamId,
        tournamentId: this.$route.params.tournamentId,
        token: this.$route.params.tk,
      }
      this.loading = true
      this.acceptInvitation(payload)
        .then((result) => {
          this.message = result
        })
        .catch((error) => {
          if (error.response.data.error && error.response.data.error.reason) {
            this.message = error.response.data.error.reason
          } else this.message = this.$t('error.apiResponses.messageNotDefined')
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style>
.logo {
  margin: auto;
  max-width: 250px;
}
.bg {
  /* background-image: url(/dark-material-bg.jpg); */
  background-size: cover;
}
#inspire {
  background: none;
}
.footer-bg {
  color: white !important;
  background-color: transparent !important;
}
</style>
